var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ContentAPIService from './contentAPIService';
import { contentNotFound, typeCheckContent } from '../helpers';
import { Apps } from '../entities/Utils';
export default class ContentService {
    constructor(props) {
        this._loadContent = (target, path) => __awaiter(this, void 0, void 0, function* () {
            const contentAPIService = new ContentAPIService(Object.assign(Object.assign({}, this.config), { getContentSignature: this.getContentSignature }));
            this.data[target] = yield contentAPIService.load(path);
        });
        this.getAllContent = () => {
            if (!this.data) {
                throw new Error('Tried to access "data" but nothing is loaded yet.');
            }
            return this.data;
        };
        this.getLevels = () => {
            if (!this.data.levels) {
                throw new Error('Tried to access "levels" but nothing is loaded yet.');
            }
            return this.data.levels;
        };
        this.getSections = () => {
            if (!this.data.sections) {
                throw new Error('Tried to access "sections" but nothing is loaded yet.');
            }
            return this.data.sections;
        };
        this.getBlocks = () => {
            if (!this.data.blocks) {
                throw new Error('Tried to access "blocks" but nothing is loaded yet.');
            }
            return this.data.blocks;
        };
        this.getContent = () => {
            if (!this.data.content) {
                throw new Error('Tried to access "content" but nothing is loaded yet.');
            }
            return this.data.content;
        };
        this.getABCContent = () => {
            if (!this.data.abc) {
                throw new Error('Tried to access "abc" but nothing is loaded yet.');
            }
            return this.data.abc;
        };
        this.getBlock = (id) => {
            const block = this.getBlocks()[id];
            if (!block) {
                contentNotFound('Block', id);
            }
            return block;
        };
        this.getSection = (id) => {
            const section = this.getSections()[id];
            if (!section) {
                contentNotFound('Section', id);
            }
            return section;
        };
        this.getLevel = (id) => {
            const level = this.getLevels()[id];
            if (!level) {
                contentNotFound('Level', id);
            }
            return level;
        };
        this.getExercise = (title) => {
            const exercise = this.getContent()[title];
            if (!exercise) {
                contentNotFound('Exercise', title);
            }
            return typeCheckContent(title, exercise, 'exercise');
        };
        this.getComic = (title) => {
            const comic = this.getContent()[title];
            if (!comic) {
                contentNotFound('Comic', title);
            }
            return typeCheckContent(title, comic, 'comic');
        };
        this.getLesson = (title) => {
            const lesson = this.getContent()[title];
            if (!lesson) {
                contentNotFound('Lesson', title);
            }
            return typeCheckContent(title, lesson, 'lesson');
        };
        this.getBossFight = (title, level) => {
            var _a;
            let bossFight = this.getContent()[title];
            if (!bossFight) {
                contentNotFound('BossFight', title);
            }
            if ('exercisesByLevel' in bossFight && bossFight.exercisesByLevel) {
                bossFight = Object.assign(Object.assign({}, bossFight), { exercises: (_a = bossFight.exercisesByLevel[level]) !== null && _a !== void 0 ? _a : bossFight.exercisesByLevel[1] });
            }
            return typeCheckContent(title, bossFight, 'bossFight');
        };
        this.getVideo = (title) => {
            const video = this.getContent()[title];
            if (!video) {
                contentNotFound('Video', title);
            }
            return typeCheckContent(title, video, 'video');
        };
        this.config = props.config;
        this.getContentSignature = props.getContentSignature;
        this.data = {};
    }
    loadContent(locale) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.config.app === Apps.junior) {
                return Promise.all([
                    this._loadContent('sections', 'junior/content/sections.json'),
                    this._loadContent('content', 'junior/content/content.json'),
                    this._loadContent('levels', 'junior/content/levels.json'),
                    this._loadContent('blocks', 'junior/content/blocks.json'),
                    this._loadContent('cinemaMovies', 'junior/content/cinema.json'),
                ]);
            }
            else if (this.config.app === Apps.abc) {
                return this._loadContent('abc', `abc/content/languages/${locale}.json`);
            }
            throw new Error(`Loading content for app "${this.config.app}" is not supported.`);
        });
    }
}
//# sourceMappingURL=contentService.js.map